import { AccordionDetails, AccordionSummary } from '@material-ui/core';
import React, { FC } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useShopConfig } from '../../../hooks/shopConfig';
import StyledAccordion from '../../StyledAccordion/StyledAccordion';
import TypographyWrapper from '../../TypographyWrapper/TypographyWrapper';
import { FAQ } from '../../../types/shopConfig/shopConfigV2';
import { FAQTitle } from '../components/FAQComponents';
import { isPanEUSite } from '../../../util/international';

export const PaymentFAQAccordionSection: FC = () => {
  const shopConfig = useShopConfig();
  const siteIsPanEUOnly = isPanEUSite(shopConfig);
  const {
    copy: { faqCopy },
  } = shopConfig;

  const highlightedCards = siteIsPanEUOnly
    ? 'Visa, Mastercard, Carte Bancaire (CB), Girocard, Maestro, Bancomat/PagoBancomat, V-Pay, American Express, and Discover'
    : 'American Express, Visa, MasterCard, and Discover.';

  return (
    <StyledAccordion name="payment-methods">
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel3a-content"
        id="panel3a-header"
      >
        <h4>
          <FAQTitle>{faqCopy[FAQ.Payment]?.title || 'What payment methods are accepted?'}</FAQTitle>
        </h4>
      </AccordionSummary>
      <AccordionDetails>
        <TypographyWrapper variant="body1">
          {faqCopy[FAQ.Payment]?.description ||
            `All major credit and debit cards are accepted for payment, including: ${highlightedCards}`}
        </TypographyWrapper>
      </AccordionDetails>
    </StyledAccordion>
  );
};
